// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vj-history-filter{min-width:326px;height:auto}.vj-history-filter .session-history-form{text-align:right}
`, "",{"version":3,"sources":["webpack://./app/_react_/components/vj-filter/styles.scss"],"names":[],"mappings":"AAAA,mBACI,eAAgB,CAChB,WAAY,CAFhB,yCAKQ,gBAAiB","sourcesContent":[".vj-history-filter {\n    min-width: 326px;\n    height: auto;\n\n    .session-history-form {\n        text-align: right;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
